(function () {
  const ImproveTextOpenai = () => {
    const disableInput = (input) => {
      input.addClass('transition-transform', 'animate-pulse', 'bg-gradient-to-r', 'from-gray-100', 'to-gray-300');
      input.is('trix-editor') ? input.attr('contenteditable', false) : input.attr('readonly', true);
    }

    const activeInput = (input) => {
      input.removeClass('transition-transform', 'animate-pulse', 'bg-gradient-to-r', 'from-gray-100', 'to-gray-300');
      input.is('trix-editor') ? input.attr('contenteditable', true) : input.attr('readonly', false);
    }

    const applyContent = (content, destinationInput) => {
      if (destinationInput.is('trix-editor')) {
        destinationInput.first().editor.loadHTML(content);
      } else {
        destinationInput.text(content);
      }
    }

    const handlePostRequest = async (url, form, destinationInput) => {
      try {
        const response = await fetch(url, {
          method: 'POST',
          body: form,
          headers: { 'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content }
        })

        const data = await response.json();
        activeInput(destinationInput);

        showConfirmationModal(data.result, destinationInput);
      } catch (error) {
        console.error('Erro: ', error);
        activeInput(destinationInput);
      }
    }

    const showConfirmationModal = (newContent, destinationInput) => {
      const modal = u('#openai-improve-text-modal');
      const preview = u('#openai-improve-text-preview');
      const confirmBtn = u('#openai-improve-text-confirm-btn');

      if (!modal) {
        applyContent(newContent, destinationInput);
        return;
      }

      preview.html(newContent);

      modal.removeClass('hidden');

      confirmBtn.first().addEventListener('click', () => {
        applyContent(newContent, destinationInput);
        modal.addClass('hidden');
      }, { once: true });
    }

    return {
      updateInput(el) {
        const url = el.dataset.url;
        const options = JSON.parse(el.dataset.options);
        const destinationInput = u('#' + el.dataset.inputUpdate);

        disableInput(destinationInput);

        var form = new FormData();

        options.forEach(option => {
          const value = document.querySelector(`.js-${option}`)?.value || '';
          form.append(`data[${option}]`, value);
        });

        
        handlePostRequest(url, form, destinationInput);
      }
    }
  };

  if (typeof window !== 'undefined') {
    window.ImproveTextOpenai = ImproveTextOpenai;
  }
})();
